export const NO_RESULTS_MESSAGES = [
    "I don’t see any matches. I can monitor flights for you.",
    "I can’t find parties to connect with. I can keep searching for options.",
    "I’m not seeing good matches. I can keep looking for flights.",
    "I don’t have flight matches yet. I can watch for new options.",
    "I can’t find options that fit. I can monitor for matching details.",
    "I’m not seeing parties to join. I can keep searching for flights and email you.",
    "I don’t see flights that match. Hit assign to agent and I can monitor further.",
    "I can’t find matches right now. I can watch for matches and notify you.",
    "I’m not seeing good options. I can monitor flight updates and keep you posted.",
    "I don’t have parties to connect. I can watch for matches and let you know.",
    "I can’t find suitable flights. I can search for better options and email you.",
    "I’m not seeing matches for you. I can look for flights and keep you posted.",
    "I don’t see options that fit. I can monitor for matches and let you know.",
    "I can’t find parties that match. I can keep looking for you and notify you.",
    "I’m not seeing good flights. I can watch for new options and email you.",
    "I don’t have matches to show. I can monitor flight updates and keep you posted.",
    "I can’t find flights that work. I can monitor for new options.",
    "I’m not seeing parties to connect. I can watch for better options.",
    "I don’t see suitable matches now. I can email you when if I find some good options.",
    "I can’t find flight options. I can monitor for matching details."
  ];

  export const EXACT_MATCH_MESSAGES = [
    {
      singular: "I found {count} match that aligns with your plans!",
      plural: "I found {count} matches that align with your plans!"
    },
    {
      singular: "I’ve got {count} good party to connect with!",
      plural: "I’ve got {count} good parties to connect with!"
    },
    {
      singular: "I see {count} option that matches your travel plans!",
      plural: "I see {count} options that match your travel plans!"
    },
    {
      singular: "I found {count} party that fits your request well!",
      plural: "I found {count} parties that fit your request well!"
    },
    {
      singular: "I’ve got {count} match for your travel plans!",
      plural: "I’ve got {count} matches for your travel plans!"
    },
    {
      singular: "I see {count} good option for your travel needs!",
      plural: "I see {count} good options for your travel needs!"
    },
    {
      singular: "I found {count} party that aligns with your request!",
      plural: "I found {count} parties that align with your request!"
    },
    {
      singular: "I’ve got {count} option that suits your plans!",
      plural: "I’ve got {count} options that suit your plans!"
    },
    {
      singular: "I see {count} other party for you to consider!",
      plural: "I see {count} other parties for you to consider!"
    },
    {
      singular: "I found {count} good match for your flight plans!",
      plural: "I found {count} good matches for your flight plans!"
    }
  ];